// extracted by mini-css-extract-plugin
module.exports = {"label":"CryptoRewardsPaneSumPicker__label__By0B5","inputWrapper":"CryptoRewardsPaneSumPicker__inputWrapper__eSYX-"};